import { routesDashboard } from '@/pages/routes.dashboard';
import { Menu } from '@/components/shared';

export function MenuDashboard() {
  const [{ children: routes }] = routesDashboard;

  return <Menu routes={routes} />;
}
